module.exports = __webpack_public_path__ + "static/img/20wanan.9fdac2ce.gif";